import React from 'react';
import {markers} from '../../libs/config';

class Header extends React.Component {
  render() {
    if(this.props.mobView){
      let style = {
        background:'#0f72a9',
        padding:'10px',
        display:'flex',
        flexDirection:'column',
        color:'white',
        justifyContent:'center',
        alignContent:'center',
        alignItems:'center',
        marginBottom:'2px'
      };
      return(
        <div style={style}>
          <img src={markers.nepal_logo} style={{height:'100px',width:'100px'}} className="img-responsive" alt="not found"/>
          <h5><b>Government of Nepal</b></h5>
          <h5><b>Flood Forecasting Division</b></h5>
        </div>
      );
    }else{
      return (
        <div id="head" className="col-md-12 inline-it">
          <div className="col-md-4 center">
            {/*<img src="./np_logo_small.png" className="img-responsive"  />*/}
            <img src={markers.nepal_logo} className="img-responsive" style={{height:'60px', width:'65px', marginTop:'7px'}} alt="not found"/>
          </div>
          <div className="header col-md-4">
            <h6><b>Government of Nepal</b></h6>
            
            <h6><b>Water and Energy Commission Secretariat</b></h6>
            <h6><b>Centre of Hydrology and Water Resourses Research</b></h6>
            <h6><b>Flood Forecasting Division</b></h6>
            {/*<h5><b>Flood Forecasting Section</b></h5>*/}
          </div>
          <div className="col-md-4 center">
            {/*<img src="./np_logo_small.png" className="img-responsive"  />*/}
            <img src={markers.nepal_flag} style={{height:'60px', marginTop:'7px'}} className="img-responsive" alt="not found"/>
          </div>
        </div>
      );
    }
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/common/Header.js